var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MolIconButton',{class:_vm.css(),attrs:{"icon-name":"link","type":_vm.MolIconButtonTypeEnum.SECONDARY,"on-click":_vm.onClick,"title":_vm.t('module.inbox.send_ordering_link_button_label')}})}
var staticRenderFns = []

export { render, staticRenderFns }